// extracted by mini-css-extract-plugin
export default {"confirmation":"Form__confirmation___t4TAo","handleNext":"Form__handleNext___U47ib"};